(function () {

    'use strict';

    angular.module('iplusjs.utils.focusFirst', [])
        .directive('iplusjsFocusFirst', focusFirst);

    focusFirst.$inject = [];
    function focusFirst() {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                $scope.$watch($attrs.iplusjsFocusFirst, function (value) {
                    var firstFocusEl;

                    if (value) {
                        firstFocusEl = $element[0].querySelector('[tabindex="0"]');

                        if (firstFocusEl && angular.isFunction(firstFocusEl.focus)) {
                            firstFocusEl.focus();
                        }
                    }
                });
            }
        };
    }

})();
